module.exports = __webpack_public_path__ + "static/media/121.4f2af7a4.jpg";